import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';

interface JobHeaderProps {
  title: string;
  location: string;
}

export const JobHeader: React.FC<JobHeaderProps> = ({ title, location }) => {
  const [hovered, setHovered] = useState<string | null>(null);

  return (
    <motion.section 
      className="pt-32 sm:pt-40 relative overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="page-padding">
        <div className="container-medium">
          <div className="padding-large">
            <Link 
              to="/careers" 
              className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6 sm:mb-8 transition-colors text-sm sm:text-base"
              onMouseEnter={() => setHovered('back')}
              onMouseLeave={() => setHovered(null)}
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Link>
            
            <SectionHeading caption="CAREERS" title={title} description={location} />
            
          </div>
        </div>
      </div>
    </motion.section>
  );
};
